/* eslint-disable linebreak-style */
import isBrowser from 'utils/isBrowser';

export function pageview(code) {
  if (isBrowser()) {
    window.gtag('config', code, {
      page_path: window.location.pathname + window.location.search,
    });
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export function event(data = {}) {
  if (isBrowser() && data.category && data.action) {
    window.gtag('event', data.action, {
      event_category: data.category,
      event_label: data.label,
      value: data.value,
      nonInteraction: data?.nonInteraction
    });
  }
}

export function eventSocial(data = {}) {
  if (isBrowser() && data.socialNetwork && data.socialAction) {
    window.gtag('event', data.socialAction, { method: data.socialNetwork });
  }
}

export function exception(description = '', fatal = false) {
  if (isBrowser() && description) {
    window.gtag('event', 'exception', { description, fatal });
  }
}
